import { StaticImage } from "gatsby-plugin-image";

const PlaceholderMap: React.FC = () => {
  return (
    <div
      sx={{
        position: "absolute",
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
      }}
    ></div>
  );
};
export default PlaceholderMap;
